import { useEffect, useState } from "react";
import { selectSupplierServiceTypesLoadingPag, selectSupplierServiceTypesPag } from "../../redux/supplierServiceTypes/selectors";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { createSupplierServiceType, deleteSupplierServiceType, editSupplierServiceType, getSupplierServiceTypesPag } from "../../redux/supplierServiceTypes/thunks";
import { openModal } from "../../redux/modal/modalSlice";
import { useTranslation } from "react-i18next";

const initialSortOptions = {
    columna: "supplierServiceTypeId",
    sortOrderAsc: true
}

function SupplierServiceTypeManagement() {
    const { t } = useTranslation();
    const supplierServiceTypes = useSelector(selectSupplierServiceTypesPag);
    const dispatch = useDispatch();
    const loading = useSelector(selectSupplierServiceTypesLoadingPag);
    const [sortOptions, setSortOptions] = useState(initialSortOptions);    

    useEffect(()=>{
        getListSupplierServiceTypes(mapPageInfo(supplierServiceTypes));
    }, [])

    function mapPageInfo(supplierServiceTypesData){
        return {
            pageIndex: supplierServiceTypesData.pageIndex ?? 0,
            pageSize: supplierServiceTypesData.pageSize ?? 10,
            orderByField:  supplierServiceTypesData.columna ?? "supplierServiceTypeId",
            orderByAscending: supplierServiceTypesData.sortOrderAsc ?? true,
            searchString: supplierServiceTypesData.searchString ?? ""
        }
    }

    const getListSupplierServiceTypes = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
        {
            query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
        }
        dispatch(getSupplierServiceTypesPag({query}));
    }

    const columnsSupplierServiceTypes = [
        <Column sortIndex={1} key={"supplier-1"} dataField="supplierServiceTypeId" caption={t("Code")} allowEditing={false} allowCreating={false}/>, 
        <Column key={"supplier-2"} dataField="description" caption={t("Description")} dataType="string" />
    ] 

    function handleSaveNewSupplierClick(value, closeCreateModal) {   
        const description = value.description?.trim();    
        if(description){
            const descriptionExists = supplierServiceTypes.elements?.some(supplierServiceType => supplierServiceType.description.toLowerCase() === description.toLowerCase());
            if(descriptionExists)
                dispatch(openModal({ type: "warning", message: t("SupplierServiceTypeAlreadyExists")}))
            else{
                const supplierServiceTypeParams ={
                    body:{
                        description: description
                    }
                }
                dispatch(createSupplierServiceType(supplierServiceTypeParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListSupplierServiceTypes(mapPageInfo({...supplierServiceTypes, ...sortOptions}));
                        closeCreateModal();
                    }
                })
            }    
        }else{
           dispatch(openModal({ type: "warning", message: t("MandatoryField")?.replace("{0}", t("Description")) }));
        }       
    }    

    const handleEditClick = (value, closeEditModal) => {
        const description = value.description?.trim() ; 
        if(description){
            const descriptionExists = supplierServiceTypes.elements?.some(supplier => supplier.description.toLowerCase() === description.toLowerCase());            
            if(descriptionExists && description.toLowerCase() !== supplierServiceTypes.elements?.find(supplier => supplier.supplierServiceTypeId === value.supplierServiceTypeId)?.description.toLowerCase())
                dispatch(openModal({ type: "warning", message: t("SupplierServiceTypeAlreadyExists")}))
            else{
                const editSupplierServiceTypeParams ={
                    param: value.supplierServiceTypeId,
                    supplierServiceTypeId: value.supplierServiceTypeId,
                    body:{        
                        description: description
                    } 
                }
                dispatch(editSupplierServiceType(editSupplierServiceTypeParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListSupplierServiceTypes(mapPageInfo({...supplierServiceTypes, ...sortOptions}));
                        closeEditModal()
                    }    
                })
            }
        }else{
            dispatch(openModal({ type: "warning", message: t("MandatoryField")?.replace("{0}", t("Description")) }));
        }             
    }

    const handleDeleteClick = (value, closeDeleteModal) => {
        const deleteSupplierServiceTypeParams ={
            param: value.supplierServiceTypeId,
            supplierServiceTypeId: value.supplierServiceTypeId,
        }
        dispatch(deleteSupplierServiceType(deleteSupplierServiceTypeParams)).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                getListSupplierServiceTypes(mapPageInfo({...supplierServiceTypes, ...sortOptions}));
                closeDeleteModal();
            }
        })  
    }

    function allowDelete(rowData){
        return rowData.data.custom;
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable
                sectionTitle={t("SupplierServiceTypes")} 
                masterTitle={t("SupplierServiceType")} 
                itemIdField={"supplierServiceTypeId"} 
                itemDescriptionField={"description"} 
                loading={loading} 
                getData={getListSupplierServiceTypes} 
                dataSource={supplierServiceTypes} 
                columnasTabla={columnsSupplierServiceTypes} 
                onCreate={handleSaveNewSupplierClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                numElements={[10, 20, 30]}
                allowDelete={allowDelete}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
        </div>
    )
}
export default SupplierServiceTypeManagement;
